import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from "@material-ui/core";
import classNames from 'classnames';
import AppColor from "../../utilities/AppColor";
import { getIn } from "formik";
import MultiSelect from "react-multi-select-component";
import { FormGroup } from "reactstrap";

const useStyles = makeStyles(() => ({
    input: {
        color: AppColor.mainColor,
        '--rmsc-border': AppColor.mainBlue,
        '--rmsc-main': AppColor.mainBlue,
        '& .dropdown-content': {
            zIndex: 100,
            backgroundColor: '#FFFF',
            marginLeft: '10px'
        },
        '&>div': {
            border: `1px solid ${AppColor.mainBlue}`,
            boxSizing: 'border-box',
            boxShadow: 'none',
            borderRadius: '11px',
            '&:focus': {
                border: `1px solid ${AppColor.mainBlue}`,
                boxSizing: 'border-box',
                boxShadow: 'none',
                borderRadius: '11px',
                color: AppColor.mainBlue
            },
            '&:focus-within': {
                boxShadow: 'none',
                borderColor: AppColor.mainBlue
            },
            '&.dropdown-container>div.dropdown-content>div.panel-content>div.select-panel': {
                '&>label.select-item': {
                    marginTop: '10px',
                    '&>div': {
                        display: 'inline-flex',
                        '&>span': {
                            marginTop: -2
                        }
                    }
                },
                '&>ul>li>label.select-item': {
                    '&>div': {
                        display: 'inline-flex',
                        '&>span': {
                            marginTop: -2
                        }
                    }
                }
            }
        },
        '& input[type="checkbox"]': {
            width: '1rem',
            height: '1rem',
            '-webkit-appearance': 'none',
            '-moz-appearance': 'none',
            '-o-appearance': 'none',
            appearance: 'none',
            background: AppColor.white,
            border: `2px solid ${AppColor.mainBlue}`,
            borderRadius: 4,
            marginLeft: '10px',
            paddingRight: '10px'
        },
        '& .select-item.selected input[type="checkbox"]': {
            background: AppColor.mainBlue
        }
    },
    label: {
        fontSize: 14,
        color: AppColor.black,
        fontWeight: '500'
    },
    strongText: {
        fontWeight: 700
    }
}))

const AppMultipleSelect = (props) => {
    const {
        field, form, options, disableSearch, className, inputContainerClass,
        placeholder, selectChange
    } = props;
    const classes = useStyles();
    const { name, value = [], ...rest } = field;
    const { errors, touched, isValid, handleChange, handleBlur } = form;
    const error = getIn(errors, name);
    const touch = getIn(touched, name);
    let showError = error && touch;
    const { t } = useTranslation();

    const _handleChange = (selected) => {
        handleChange({
            target: {
                name,
                value: selected
            }
        });
        selectChange && selectChange({
            target: {
                name,
                value: selected
            }
        });
    };

    return (
        <FormGroup className={className}>
            <MultiSelect
                options={options}
                value={value}
                onChange={_handleChange}
                labelledBy="Select"
                selectAllLabel={t('label.all')}
                disableSearch={disableSearch}
                className={classNames([classes.input, inputContainerClass])}
                overrideStrings={{
                    "allItemsAreSelected": t("label.all_items_are_selected"),
                    "clearSearch": t('label.clear'),
                    "noOptions": t('label.no_options'),
                    "search": t('label.search'),
                    "selectAll": t('label.select_all'),
                    "selectSomeItems": placeholder ? placeholder : t('label.select')
                }}
            />
        </FormGroup>
    );
}

AppMultipleSelect.propTypes = {
    field: PropTypes.object.isRequired,
    form: PropTypes.object.isRequired,
    placeholder: PropTypes.any,
    options: PropTypes.array,
    selectChange: PropTypes.func,
    disableSearch: PropTypes.any,
    className: PropTypes.any,
    inputContainerClass: PropTypes.any
};

AppMultipleSelect.defaultProps = {
    options: []
};

export default AppMultipleSelect;
